export default __webpack_public_path__ + "static/media/BrainBreak cards28.e39f20e9.png";